// De munt van de zaak voor de widget (Zweden/Polen, Martijn 17-10-2026).
//
// Waarom: geldTekst() stond zonder munt vast op euro. Een Zweedse zaak toonde zo "€ 120,00" voor een tafel van 120 kronen, en een
// Poolse "€" voor zloty. Bij het opstarten vraagt de widget een keer de munt van de zaak op (api/Widget/GetCompanyCurrency, veld
// currencyCode) en zet die als standaard voor geldTekst (lib/opmaak.js). Lukt het niet, dan blijft het euro, zoals altijd.

import axios from 'axios';
import { apiAdres } from '../instellingen';
import { zetWinkelValuta } from './opmaak';

/** Leest de ISO-code uit het antwoord van GetCompanyCurrency ({ value: { currencyCode } } of { currencyCode }). */
export function valutaUitAntwoord(data) {
    const v = data?.value ?? data;
    const code = String(v?.currencyCode || '').trim().toUpperCase();
    return /^[A-Z]{3}$/.test(code) ? code : null;
}

/** Vraagt de munt van de zaak op voor de sleutel in het adres en zet hem als standaard. Gooit nooit. */
export async function startWinkelvaluta(zoek = window.location.search) {
    try {
        const key = new URLSearchParams(zoek || '').get('key');
        if (!key) return null;
        const basis = String(apiAdres || '').trim().replace(/\/$/, '');
        const antwoord = await axios.get(`${basis}/api/Widget/GetCompanyCurrency?key=${encodeURIComponent(key)}`);
        const code = valutaUitAntwoord(antwoord?.data);
        if (code) zetWinkelValuta(code);
        return code;
    } catch {
        return null;
    }
}
